(() => {
  'use strict';

  const instances = new WeakMap();

  const BOOKING_CTA_TEXT = 'See Available Times';
  const BOOKING_LINK_FRAGMENT = '/products/split-system-deep-clean';


  const NORTH_BRISBANE_SUBURBS = [
    'Bracken Ridge', 'Bridgeman Downs', 'Chermside West', 'Stafford Heights',
    'Albany Creek', 'Eatons Hill', 'Murrumba Downs', 'North Lakes', 'Mango Hill',
    'Wavell Heights', 'Nudgee Beach', 'Upper Kedron', 'Everton Park',
    'Carseldine', 'Chermside', 'Strathpine', 'Redcliffe', 'Narangba', 'Dakabin',
    'Kallangur', 'Lawnton', 'Petrie', 'Rothwell', 'Griffin', 'Aspley', 'Banyo',
    'Boondall', 'Brighton', 'Deagon', 'Fitzgibbon', 'Geebung', 'McDowall',
    'Mitchelton', 'Northgate', 'Nudgee', 'Nundah', 'Sandgate', 'Shorncliffe',
    'Taigum', 'Virginia', 'Zillmere', 'Bellmere', 'Burpengary', 'Caboolture',
    'Deception Bay', 'Morayfield', 'Scarborough', 'Albion', 'Alderley', 'Ascot', 'Clayfield',
    'Gordon Park', 'Grange', 'Hamilton', 'Hendra', 'Kedron', 'Lutwyche',
    'Stafford', 'Wilston', 'Windsor', 'Brendale', 'Bray Park'
  ].sort((a, b) => b.length - a.length);

  function findRecentJobLocation(card) {
    const text = card?.textContent?.replace(/\s+/g, ' ').trim() || '';
    return NORTH_BRISBANE_SUBURBS.find((suburb) =>
      new RegExp(`\\b${suburb.replace(/[.*+?^${}()|[\\]\\]/g, '\\$&')}\\b`, 'i').test(text)
    ) || 'North Brisbane';
  }

  function hideHomeJobElement(element) {
    if (!element) return;
    element.classList.add('seq-home-job-card__hidden');
    element.setAttribute('aria-hidden', 'true');
  }

  function setHomeJobButtonLabel(link, label) {
    if (!link) return;
    link.textContent = label;
    link.removeAttribute('aria-hidden');
    link.classList.remove('seq-home-job-card__hidden');
  }

  function normaliseRecentJobCards(scope = document) {
    const cards = new Set();

    if (scope.matches?.('.seq-home__recent-jobs .seq-result-card')) cards.add(scope);
    scope.querySelectorAll?.('.seq-home__recent-jobs .seq-result-card').forEach((card) => cards.add(card));

    cards.forEach((card) => {
      const locationText = findRecentJobLocation(card);
      const head = card.querySelector('.seq-result-card__head');
      const media = card.querySelector('.seq-ba-slider, [data-seq-ba-slider]');
      let body = card.querySelector('.seq-result-card__body');

      if (!head || !media) return;

      card.classList.add('is-home-job-card');

      const title = head.querySelector('h3');
      if (title && title.parentElement !== head) head.appendChild(title);

      let location = head.querySelector('.seq-home-job-card__location');
      if (!location) {
        location = document.createElement('span');
        location.className = 'seq-home-job-card__location';
        head.insertBefore(location, title || head.firstChild);
      }
      location.textContent = locationText;

      Array.from(head.children).forEach((child) => {
        if (child !== location && child !== title) hideHomeJobElement(child);
      });
      Array.from(head.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) node.nodeValue = '';
      });

      if (!body) {
        body = document.createElement('div');
        body.className = 'seq-result-card__body';
        card.appendChild(body);
      }

      const description = card.querySelector('.seq-suburb-job-card__description')
        || Array.from(body.querySelectorAll('p')).find((paragraph) => paragraph.textContent.trim());

      if (description) {
        description.classList.add('seq-home-job-card__description');
        description.classList.remove('seq-home-job-card__hidden');
        description.removeAttribute('aria-hidden');
        if (description.parentElement !== body) body.insertBefore(description, body.firstChild);
      }

      const links = Array.from(card.querySelectorAll('a[href]'));
      const bookingLink = links.find((link) =>
        link.matches('[data-open-booking]') || link.getAttribute('href')?.includes(BOOKING_LINK_FRAGMENT)
      );
      const jobLink = links.find((link) => {
        if (link === bookingLink) return false;
        const label = link.textContent.replace(/\s+/g, ' ').trim();
        return /view (?:the )?(?:full )?job|see what was found|view job/i.test(label);
      }) || links.find((link) => {
        if (link === bookingLink || link.contains(media) || link.contains(head)) return false;
        const href = link.getAttribute('href') || '';
        return /\/(pages|blogs)\//i.test(href) && !href.includes(BOOKING_LINK_FRAGMENT);
      });

      let actions = body.querySelector('.seq-home-job-card__actions');
      if (!actions) {
        actions = document.createElement('div');
        actions.className = 'seq-home-job-card__actions';
        body.appendChild(actions);
      }

      if (jobLink) {
        jobLink.classList.add('seq-home-job-card__button', 'seq-home-job-card__button--job');
        setHomeJobButtonLabel(jobLink, 'View Job');
        actions.appendChild(jobLink);
      }

      let resolvedBookingLink = bookingLink;
      if (!resolvedBookingLink) {
        resolvedBookingLink = document.createElement('a');
        resolvedBookingLink.href = BOOKING_LINK_FRAGMENT;
        resolvedBookingLink.setAttribute('data-open-booking', '');
        resolvedBookingLink.setAttribute('data-booking-source', 'homepage_recent_job');
        resolvedBookingLink.setAttribute('aria-haspopup', 'dialog');
      }

      resolvedBookingLink.classList.add('seq-home-job-card__button', 'seq-home-job-card__button--booking');
      setHomeJobButtonLabel(resolvedBookingLink, BOOKING_CTA_TEXT);
      actions.appendChild(resolvedBookingLink);

      Array.from(body.children).forEach((child) => {
        if (child !== description && child !== actions) hideHomeJobElement(child);
      });
      Array.from(body.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) node.nodeValue = '';
      });

      links.forEach((link) => {
        if (link !== jobLink && link !== resolvedBookingLink) hideHomeJobElement(link);
      });

      Array.from(card.children).forEach((child) => {
        const containsKeptContent = child === head || child === media || child === body
          || child.contains(head) || child.contains(media) || child.contains(body);
        if (!containsKeptContent) hideHomeJobElement(child);
      });
    });
  }

  function setBookingCtaLabel(element) {
    if (!element) return;

    const ariaLabel = element.getAttribute('aria-label');
    if (ariaLabel && /book|available|times|your clean/i.test(ariaLabel)) {
      element.setAttribute('aria-label', BOOKING_CTA_TEXT);
    }

    const explicitLabel = element.querySelector('[data-booking-cta-label]');
    if (explicitLabel) {
      explicitLabel.textContent = BOOKING_CTA_TEXT;
      return;
    }

    const leafLabel = Array.from(element.querySelectorAll('span, b, strong'))
      .find((node) => {
        if (node.children.length) return false;
        const text = node.textContent.trim();
        return /book|available|times|your clean/i.test(text);
      });

    if (leafLabel) {
      leafLabel.textContent = BOOKING_CTA_TEXT;
      return;
    }

    const directTextNode = Array.from(element.childNodes)
      .find((node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim());

    if (directTextNode) {
      directTextNode.nodeValue = ` ${BOOKING_CTA_TEXT} `;
      return;
    }

    if (!element.children.length) {
      element.textContent = BOOKING_CTA_TEXT;
    }
  }

  function normaliseBookingCtas(scope = document) {
    const selectors = [
      '[data-open-booking]',
      `a[href*="${BOOKING_LINK_FRAGMENT}"]`
    ];

    const candidates = new Set();

    selectors.forEach((selector) => {
      if (scope.matches?.(selector)) candidates.add(scope);
      scope.querySelectorAll?.(selector).forEach((element) => candidates.add(element));
    });

    candidates.forEach(setBookingCtaLabel);
  }

  function initHeroVideo(hero, cleanup) {
    const video = hero?.querySelector('[data-seq-hero-video]');
    if (!video) return;

    const fallbackImage = hero.querySelector('[data-seq-hero-image]');
    const desktopQuery = window.matchMedia('(min-width: 769px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = Boolean(navigator.connection?.saveData);
    let activeSrc = '';
    let idleCallbackId = null;
    let startTimerId = null;
    let startQueued = false;

    const removeQueryListener = (query, handler) => {
      if (typeof query.removeEventListener === 'function') query.removeEventListener('change', handler);
      else query.removeListener?.(handler);
    };

    const addQueryListener = (query, handler) => {
      if (typeof query.addEventListener === 'function') query.addEventListener('change', handler);
      else query.addListener?.(handler);
    };

    const syncVideoPoster = () => {
      const posterSrc = fallbackImage?.currentSrc || fallbackImage?.src;
      if (!posterSrc) return;

      // Reuse the responsive hero image the browser has already selected. This
      // gives the video an immediate, lightweight first paint without fetching
      // a second fixed-width poster image.
      if (video.poster !== posterSrc) video.poster = posterSrc;
      video.classList.add('has-poster');
    };

    const cancelQueuedStart = () => {
      if (idleCallbackId !== null && 'cancelIdleCallback' in window) {
        window.cancelIdleCallback(idleCallbackId);
      }
      if (startTimerId !== null) window.clearTimeout(startTimerId);

      idleCallbackId = null;
      startTimerId = null;
      startQueued = false;
    };

    const resetVideo = () => {
      video.pause();
      video.classList.remove('is-playing');
      activeSrc = '';
      if (video.hasAttribute('src')) {
        video.removeAttribute('src');
        video.load();
      }
    };

    const startVideo = () => {
      // Respect explicit reduced-motion and data-saving preferences; the optimised
      // responsive hero image remains visible as the fallback in either case.
      if (reducedMotionQuery.matches || saveData) {
        resetVideo();
        return;
      }

      const nextSrc = desktopQuery.matches
        ? video.dataset.desktopSrc
        : video.dataset.mobileSrc;

      if (!nextSrc) return;

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      if (activeSrc !== nextSrc) {
        activeSrc = nextSrc;
        video.classList.remove('is-playing');
        video.src = nextSrc;
        video.load();
      }

      const playPromise = video.play();
      playPromise?.catch?.(() => {
        video.classList.remove('is-playing');
      });
    };

    const queueVideoStart = () => {
      if (startQueued) return;
      startQueued = true;

      const run = () => {
        idleCallbackId = null;
        startTimerId = null;
        startQueued = false;
        startVideo();
      };

      if ('requestIdleCallback' in window) {
        idleCallbackId = window.requestIdleCallback(run, { timeout: 1500 });
      } else {
        startTimerId = window.setTimeout(run, 250);
      }
    };

    const queueAfterPageLoad = () => {
      if (document.readyState === 'complete') queueVideoStart();
      else window.addEventListener('load', queueVideoStart, { once: true });
    };

    const onVideoPreferenceChange = () => {
      if (reducedMotionQuery.matches || saveData) {
        cancelQueuedStart();
        resetVideo();
        return;
      }

      queueVideoStart();
    };

    const onPlaying = () => video.classList.add('is-playing');
    const onError = () => video.classList.remove('is-playing');

    syncVideoPoster();
    fallbackImage?.addEventListener('load', syncVideoPoster, { once: true });
    video.addEventListener('playing', onPlaying);
    video.addEventListener('error', onError);
    addQueryListener(desktopQuery, onVideoPreferenceChange);
    addQueryListener(reducedMotionQuery, onVideoPreferenceChange);
    queueAfterPageLoad();

    cleanup.push(() => {
      cancelQueuedStart();
      window.removeEventListener('load', queueVideoStart);
      fallbackImage?.removeEventListener('load', syncVideoPoster);
      video.removeEventListener('playing', onPlaying);
      video.removeEventListener('error', onError);
      removeQueryListener(desktopQuery, onVideoPreferenceChange);
      removeQueryListener(reducedMotionQuery, onVideoPreferenceChange);
      resetVideo();
    });
  }

  function initHomepage(root) {
    if (!root || instances.has(root)) return;

    const cleanup = [];
    normaliseRecentJobCards(root);
    const hero = root.querySelector('[data-seq-hero]');
    const finalSection = root.querySelector('[data-seq-final]');
    const stickyButton = root.querySelector('[data-seq-mobile-sticky]');
    const sliders = Array.from(root.querySelectorAll('[data-seq-ba-slider]'));
    const faqItems = Array.from(root.querySelectorAll('.seq-faq__item'));

    initHeroVideo(hero, cleanup);

    if (hero && stickyButton) {
      let ticking = false;

      const updateStickyButton = () => {
        ticking = false;

        if (window.matchMedia('(min-width: 769px)').matches) {
          stickyButton.classList.remove('is-visible');
          return;
        }

        const heroPassed = hero.getBoundingClientRect().bottom < 90;
        const finalVisible = finalSection
          ? finalSection.getBoundingClientRect().top < window.innerHeight
          : false;

        stickyButton.classList.toggle('is-visible', heroPassed && !finalVisible);
      };

      const requestStickyUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateStickyButton);
      };

      updateStickyButton();
      window.addEventListener('scroll', requestStickyUpdate, { passive: true });
      window.addEventListener('resize', requestStickyUpdate, { passive: true });
      window.addEventListener('orientationchange', requestStickyUpdate, { passive: true });

      cleanup.push(() => {
        window.removeEventListener('scroll', requestStickyUpdate);
        window.removeEventListener('resize', requestStickyUpdate);
        window.removeEventListener('orientationchange', requestStickyUpdate);
      });
    }

    sliders.forEach((slider) => {
      const range = slider.querySelector('[data-seq-ba-range]');
      const before = slider.querySelector('[data-seq-ba-before]');
      const line = slider.querySelector('[data-seq-ba-line]');

      if (!range || !before || !line) return;

      const updateSlider = () => {
        const value = Math.min(100, Math.max(0, Number(range.value) || 0));
        const width = slider.getBoundingClientRect().width;

        before.style.width = `${value}%`;
        line.style.left = `${value}%`;
        slider.style.setProperty('--seq-slider-width', `${width}px`);
        range.setAttribute('aria-valuetext', `${value}% before image visible`);
      };

      range.addEventListener('input', updateSlider);
      range.addEventListener('change', updateSlider);

      const resizeObserver = 'ResizeObserver' in window
        ? new ResizeObserver(updateSlider)
        : null;

      if (resizeObserver) {
        resizeObserver.observe(slider);
      } else {
        window.addEventListener('resize', updateSlider, { passive: true });
      }

      updateSlider();

      cleanup.push(() => {
        range.removeEventListener('input', updateSlider);
        range.removeEventListener('change', updateSlider);
        resizeObserver?.disconnect();

        if (!resizeObserver) {
          window.removeEventListener('resize', updateSlider);
        }
      });
    });

    faqItems.forEach((item) => {
      const onToggle = () => {
        if (!item.open) return;

        faqItems.forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      };

      item.addEventListener('toggle', onToggle);
      cleanup.push(() => item.removeEventListener('toggle', onToggle));
    });

    const ctaObserver = 'MutationObserver' in window
      ? new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                normaliseBookingCtas(node);
                normaliseRecentJobCards(node);
              }
            });
          });
        })
      : null;

    if (ctaObserver && document.body) {
      ctaObserver.observe(document.body, { childList: true, subtree: true });
      cleanup.push(() => ctaObserver.disconnect());
    }

    instances.set(root, () => cleanup.forEach((destroy) => destroy()));
  }

  function destroyHomepage(root) {
    const destroy = instances.get(root);
    if (destroy) destroy();
    instances.delete(root);
  }

  function initAll(scope = document) {
    normaliseBookingCtas(scope);
    normaliseRecentJobCards(scope);
    if (scope.matches?.('[data-seq-home]')) initHomepage(scope);
    scope.querySelectorAll?.('[data-seq-home]').forEach(initHomepage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.('[data-seq-home]')) destroyHomepage(event.target);
    event.target.querySelectorAll?.('[data-seq-home]').forEach(destroyHomepage);
  });
})();
